import React, {forwardRef} from "react";
// @material-ui/core components
import { makeStyles, Checkbox, FormControlLabel } from "@material-ui/core";
import Check from "@material-ui/icons/Check";
// core components
import GridItem from "components/Grid/GridItem.js";
import { primaryColor, blackColor, hexToRgb } from "assets/jss/material-dashboard-react.js";

const styles = {
  checkedIcon: {
    width: "19px",
    height: "19px",
    border: "1px solid rgba(" + hexToRgb(blackColor) + ", .54)",
    borderRadius: "3px",
    color: primaryColor[0] + "!important"
  },
  uncheckedIcon: {
    width: "0px",
    height: "0px",
    padding: "10px",
    border: "1px solid rgba(" + hexToRgb(blackColor) + ", .54)",
    borderRadius: "3px"
  },
};
const useStyles = makeStyles(styles);

export const CheckBoxInput = forwardRef((props, ref) => {
  const classes = useStyles();
  const fieldsize = props.fieldsize ? props.fieldsize : 12
  return (
    <GridItem xs={12} sm={12} md={fieldsize} >
      <FormControlLabel label={<span style={{ fontSize: '11pt' }}>{props.label}</span>}
                        control={<Checkbox checkedIcon={<Check className={classes.checkedIcon} />}
                                            icon={<Check className={classes.uncheckedIcon} />}
                                            size="small"
                                            {...props}/>}
                        />
    </GridItem>
  )
})
